var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
    fill: "#616874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5355 7.17157C13.7308 6.97631 13.7308 6.65973 13.5355 6.46447C13.3403 6.2692 13.0237 6.2692 12.8284 6.46447L13.5355 7.17157ZM6.46447 12.8284C6.2692 13.0237 6.2692 13.3403 6.46447 13.5355C6.65973 13.7308 6.97631 13.7308 7.17157 13.5355L6.46447 12.8284ZM12.8284 13.5355C13.0237 13.7308 13.3403 13.7308 13.5355 13.5355C13.7308 13.3403 13.7308 13.0237 13.5355 12.8284L12.8284 13.5355ZM7.17157 6.46447C6.97631 6.2692 6.65973 6.2692 6.46447 6.46447C6.2692 6.65973 6.2692 6.97631 6.46447 7.17157L7.17157 6.46447ZM18.5 10C18.5 14.6944 14.6944 18.5 10 18.5V19.5C15.2467 19.5 19.5 15.2467 19.5 10H18.5ZM10 18.5C5.30558 18.5 1.5 14.6944 1.5 10H0.5C0.5 15.2467 4.75329 19.5 10 19.5V18.5ZM1.5 10C1.5 5.30558 5.30558 1.5 10 1.5V0.5C4.75329 0.5 0.5 4.75329 0.5 10H1.5ZM10 1.5C14.6944 1.5 18.5 5.30558 18.5 10H19.5C19.5 4.75329 15.2467 0.5 10 0.5V1.5ZM12.8284 6.46447L9.64645 9.64645L10.3536 10.3536L13.5355 7.17157L12.8284 6.46447ZM9.64645 9.64645L6.46447 12.8284L7.17157 13.5355L10.3536 10.3536L9.64645 9.64645ZM13.5355 12.8284L10.3536 9.64645L9.64645 10.3536L12.8284 13.5355L13.5355 12.8284ZM10.3536 9.64645L7.17157 6.46447L6.46447 7.17157L9.64645 10.3536L10.3536 9.64645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/ExitIcon.07d24ba649debbfa3ff637d050e0f44c.svg";
export { ForwardRef as ReactComponent };